import axios from "axios";
import { config, keys, platform_name } from "../../config.env";
import { getStorage } from '../../lib'
import moment from "moment";



// const ENDPOINT_DOMAIN = config.API_ENDPOINT
const domain = config.API_ENDPOINT
const domain_ = config.APP_URL
const storage = config.STORAGE_ENDPOINT
const token_public = config.API_TOKEN
const origin = config.ORIGIN


// const API_TOKEN = environment.production ? environment.API_TOKEN_PROD : environment.API_TOKEN
// const token_ = API_TOKEN

export const login = (username, password) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/login/mod-healthsystem-dashboard`
        let body = {
            "username": username,
            "password": password
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            resolve(error.response.data)
        })
    })
}

export const logout = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/logout`
        let data = JSON.stringify({
            "refresh_token": getStorage(keys.refresh_token)
        });

        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                resolve(false)
            });
    })
}

export const profile = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/profile`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateProfile = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/profile`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const disableUser = (uid) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/user/cancel?uid=${uid}`
        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Authorization': `Bearer ${getStorage(keys.access_token)}`,
                'Platform': platform_name
            }
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                resolve(false)
            });
    })
}

export const register = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/register`
        let body = data
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            resolve(error.response.data)
        })
    })
}

export const uploadFile = (file) => {
    return new Promise((resolve) => {
        const formData = new FormData();
        formData.append('file', file);
        let url = `${storage}/logo/mod`
        const headers = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'multipart/form-data'
        };
        axios.post(url, formData, { headers }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })

    });
};

export const uploadLogo = (file) => {
    return new Promise((resolve) => {
        const url = `${storage}/logo`;
        const formData = new FormData();
        formData.append('file', file); // Directly append the File object

        const headers = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'multipart/form-data'
        };

        axios.post(url, formData, { headers })
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                resolve(false);
            });
    });
};

export const uploadProfile = (uid, formData) => {
    return new Promise((resolve) => {
        // const url = `${storage}/profile/${uid}?file_name=${uid}-${moment(Date.now()).format('YYYYMMDD_HHmmss')}`;
        // let header = {}

        const url = `${storage}/profile/${uid}`;
        const header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'multipart/form-data'
        };

        axios.post(url, formData, { headers: header }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            resolve(error.response.data)
        })

    });
};

export const uploadFileImage = (source, formData) => {
    return new Promise((resolve) => {
        // let url = `${storage}/${moment(Date.now()).format('YYYY-MM')}/${source}?file_name=${source}-${moment(Date.now()).format('YYYY-MM-DD_HHmmss')}`
        let url = `${storage}/${source}`
        const header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'multipart/form-data'
        };
        axios.post(url, formData, { headers: header }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            resolve(error.response.data)
        })
    })
}

export const uploadFileImageRegister = (source, formData) => {
    return new Promise((resolve) => {
        let url = `${storage}/public/${source}`
        const header = {
            'platform': 'mod-healthsystem-microservice'
        };
        axios.post(url, formData, { headers: header }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            resolve(error.response.data)
        })
    })
}

export const uploadFile2 = (source, formData) => {
    return new Promise((resolve) => {
        let url = `${storage}/${moment(Date.now()).format('YYYY-MM')}/${source}?file_name=${source}-${moment(Date.now()).format('YYYY-MM-DD_HHmmss')}`
        const header = {};
        axios.post(url, formData, { headers: header }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            resolve(error.response.data)
        })
    })
}

export const gender = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/data/findDropdownList?source=gender&order=line_number&sort=asc`
        let header = {
            'platform': 'mod-healthsystem-microservice',
            'Authorization': `Bearer ${token_public}`
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const titleName = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/data/findDropdownList?source=title_name&order=line_number&sort=asc`
        let header = {
            'platform': 'mod-healthsystem-microservice',
            'Authorization': `Bearer ${token_public}`
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findDepartmentFixToken = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/data/findDepartment?order=department_code&sort=desc&doc_status=W`
        let header = {
            'platform': 'mod-healthsystem-microservice',
            'Authorization': `Bearer ${token_public}`
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findPosition = (page, search, line_number) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/dropdown?page=${page}&source=title_name&order=line_number&sort=asc`
        if (line_number) {
            url += `&line_number=${line_number}`
        } else if (search) {
            url += `&search=${search}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newPosition = (position_name, position_name_short) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/dropdown`
        let body = {
            "source": "title_name",
            "name": position_name,
            "value": position_name,
            "remark": position_name_short,
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updatePosition = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/dropdown`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deletePosition = (line_number) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/dropdown?source=title_name&line_number=${line_number}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findDepartment = (page, search, department_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/department?order=updated_date&sort=desc&page=${page}`
        if (department_code) {
            url += `&department_code=${department_code}`
        } else if (search) {
            url += `&search=${search}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newDepartment = (department_name, department_name_short, number_of_people) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/department`
        let body = {
            "department_name": department_name,
            "department_name_short": department_name_short,
            "number_of_people": number_of_people
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateDepartment = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/department`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteDepartment = (department_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/department?department_code=${department_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findHospital = (page, search, hospital_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/hospital?order=updated_date&sort=desc&page=${page}`
        if (hospital_code) {
            url += `&hospital_code=${hospital_code}`
        } else if (search) {
            url += `&search=${search}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newHospital = (hospital_code, hospital_name) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/hospital`
        let body = {
            "hospital_code": hospital_code,
            "hospital_name": hospital_name
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteHospital = (hospital_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/hospital?hospital_code=${hospital_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateHospital = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/hospital`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findNews = (page, search, new_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news?page=${page}&order=updated_date&sort=desc`
        if (new_code) {
            url += `&new_code=${new_code}`
        } else if (search) {
            url += `&search=${search}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findNewsDetail = (new_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news/${new_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newNews = (new_title, new_detail, banner_status, favorite_status, remark, images) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news`
        let body = {
            "new_title": new_title,
            "new_detail": new_detail,
            "banner_status": banner_status,
            "favorite_status": favorite_status,
            "remark": remark,
            "images": images
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateNews = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteNews = (new_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news?new_code=${new_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findUserGroup = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/data/findUserGroup?order=group_code&sort=asc`
        let header = {
            'platform': 'mod-healthsystem-microservice',
            'Authorization': `Bearer ${token_public}`
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const evaluation = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/evaluation/form/mental-health`
        let body = data
        let header = {
            'platform': platform_name,
            'authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const GenerateURLThaiD = (params) => {
    return new Promise((resolve) => {

        let config = {
            method: "get",
            params: params,
            url: `${domain}/api/v1/system/auth/thaiD`,
            headers: {
                platform: "mod-healthsystem-dashboard",
                Authorization: `Bearer ${getStorage(keys.access_token)}`,
            },

        }

        axios(config).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const FindPayloadThaiD = (token) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/auth/thaiD/payload`
        let header = {
            'Authorization': `Bearer ${token}`
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const HealthBehaviorSurvey = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/evaluation/form/health-behavior-survey`
        let body = data
        let header = {
            'platform': platform_name,
            'authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findCourse = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course?order=e_learning_code&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newCourse = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateCourse = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteCourse = (code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course?e_learning_code=${code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findCourseGroup = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course-group`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newCourseGroup = (groupName) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course-group`
        let body = {
            "e_learning_group_name": groupName
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateCourseGroup = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course-group`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteCourseGroup = (groupCode) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course-group?e_learning_group_code=${groupCode}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findNewsFixToken = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news`
        let header = {
            'Authorization': `Bearer ${token_public}`,
            'Platform': 'mod-healthsystem-microservice'
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findNewsCodeFixToken = (new_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/news/${new_code}`
        let header = {
            'Authorization': `Bearer ${token_public}`,
            'Platform': 'mod-healthsystem-microservice'
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newTestRecord = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/test`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteUser = (uid) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/user?uid=${uid}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findUser = (page, search, status) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/user?order=full_name&sort=asc&page=${page}&limit=10`
        if (search) {
            url += `&search=${search}`
        }
        if (status) {
            url += `&doc_status=${status}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findUserbyType = (page, search, status, role) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/user?order=user_type_name&sort=asc&page=${page}&limit=10`
        if (search) {
            url += `&search=${search}`
        }
        if (status) {
            url += `&doc_status=${status}`
        }
        if (role !== 'null') {
            url += `&user_type=${role}`
        }
        let header = {
            'Authorization': `Bearer ${localStorage.getItem('AccessToken')}`,
            'Platform': 'mod-healthsystem-dashboard'
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateUserStatus = (uid) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/user/toggle?uid=${uid}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, {}, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateUser = (data, uid) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/user?uid=${uid}`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const refreshToken = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/refreshToken`
        let data = JSON.stringify({
            "refresh_token": getStorage(keys.refresh_token)
        });

        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                resolve(response)
            })
            .catch((error) => {
                // console.log(error);
                resolve(false)
            });
    })
}

export const myCourse = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/my-course?order=register_date&sort=desc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const startCourse = (group_code, code, register_number) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/start-course`
        let body = {
            "e_learning_group_code": group_code,
            "e_learning_code": code,
            "register_number": register_number
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const finishLesson = (group_code, code, register_number, lesson_number) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/finish-lesson`
        let body = {
            "e_learning_group_code": group_code,
            "e_learning_code": code,
            "register_number": register_number,
            "lesson_number": lesson_number
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const registerCourse = (group_code, code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course-register`
        let body = {
            "e_learning_group_code": group_code,
            "e_learning_code": code
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const cancelCourse = (group_code, code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/course-register?register_number=1`
        let body = {
            "e_learning_group_code": group_code,
            "e_learning_code": code
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.delete(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const analytics = (start, end, page, e_learning_group_code, department_code, doc_status, search) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/analytics?date_from=${start}&date_to=${end}&page=${page}`
        if (search) {
            url += `&search=${search}`
        }
        if (e_learning_group_code) {
            url += `&e_learning_group_code=${e_learning_group_code}`
        }
        if (department_code) {
            url += `&department_code=${department_code}`
        }
        if (doc_status) {
            url += `&doc_status=${doc_status}`
        }

        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findMenu = (order) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/userMenu`
        if (order) {
            url += `?order=${order}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findUserType = (group_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/userType?order=group_code&sort=asc`
        if (group_code) {
            url += `&group_code=${group_code}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateUseType = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/userType`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateUserTypeRole = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/userTypeRole/toggle`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newUserType = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/userType`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteUserType = (group_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/userType?group_code=${group_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const dropdownFormEvaluationStatus = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/evaluation-status`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const newFormEvaluation = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/evaluation-form`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findFormEvaluation = (searchQuery, doc_status_name, evaluation_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/evaluation-form?order=created_date&sort=desc`
        if (doc_status_name) {
            url += `&doc_status_name=${doc_status_name}`
        }
        if (searchQuery) {
            url += `&search=${searchQuery}`
        }
        if (evaluation_code) {
            url += `&evaluation_code=${evaluation_code}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            // 'Authorization': 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWZyZXNoX3Rva2VuIjoiOWU5MjVkNmUtMWM0Yi00NWRhLWE5YjItNGNjNjUzYjc0YTc2IiwicGxhdGZvcm0iOiJtb2QtaGVhbHRoc3lzdGVtLWRhc2hib2FyZCIsInVpZCI6IjEwMDUxIiwiaWF0IjoxNzQ2NTgzMzE2LCJleHAiOjE3NDkxNzUzMTZ9.ryyVV4JJbOUJG0Pug_yKIxDddsaiGZqRk31-odcCUhhdgkgbH8A6E4sAiFAoTpvKxlfEfWARqdr2KExEoOmhpMbPMxzybykpvOidEbODyhfNAfHim0fqzOg65GXf_uYpw9CtGMmc1vB8LSYR_hc9JoBbj8y9pzOXn9REPhU5iXvL13M2zXeH36_s39Y8FAD1Sv8Fnkog_taen8JrS1HRprzjBPy6EPJLRhbcqKlEsd5FTwkYKxUEh3OUuWc8CHYNvcxKU6bFqbtwWfSNYtCWHvytPgl_iNl97l0gOuYI2HwqhJnklXnWbz4UH5pTrpUMrnqXOJah2q6DBxkF-9sjIg',
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteFormEvaluation = (code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/evaluation-form?evaluation_code=${code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateFormEvaluation = (body) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/evaluation-form`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const getOverallEvaluation = (department, year) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/analytics/summary/evaluation-form`
        if (department) {
            url += `&department_code=${department}`
        }
        if (year) {
            url += `&year=${year}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const activateEvaluation = (code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/evaluation-form/toggle?evaluation_code=${code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, {}, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const ApiForgetPassword = async (payload) => {
    try {

        let config = {
            method: 'post', //you can set what request you want to be
            url: `${domain}/api/v1/system/forgetPassword`,
            data: { ...payload },
            headers: {
                'Content-Type': 'application/json'
            }
        }
        let result = await axios(config)
        if (result.data.status) {
            return result.data
        } else {
            return false
        }

    } catch (error) {

        return false
    }
}

export const ApiPutPassword = async (accessToken, payload) => {

    try {

        let config = {
            method: 'put', //you can set what request you want to be
            url: `${domain}/api/v1/system/putPassword`,
            data: { ...payload },
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${accessToken}`
            }
        }
        let result = await axios(config)
        if (result.data.status) {
            return result.data
        } else {
            return false
        }

    } catch (error) {

        return false
    }

}

export const initial = () => { //จำนวนการเข้าชมข่าว
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/initial`
        let header = {
            'Authorization': `Bearer ${token_public}`,
            'Platform': 'mod-healthsystem-microservice'
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const topCourse = (date_from, date_to) => { //หลักสูตรยอดนิยม
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/analytics/top-course?date_from=${date_from}&date_to=${date_to}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const ratioRegisterSuccess = (date_from, date_to, e_learning_code) => { //จำนวนการลงทะเบียนในแต่ละหลักสูตร
    return new Promise((resolve) => {
        // let url = `${domain}/api/v1/manage/e-learning/analytics/ratio-register-success?date_from=${date_from}&date_to=${date_to}&department_code=${department_code}`
        // let header = {
        //     'Authorization': `Bearer ${getStorage(keys.access_token)}`,
        //     'Platform': platform_name
        // }
        // axios.get(url, { headers: header }).then((res) => {
        //     resolve(res)
        // }).catch((error) => {
        //     resolve(false)
        // })

        let url = `${domain}/api/v1/manage/e-learning/analytics/ratio-register-success?date_from=${date_from}&date_to=${date_to}&e_learning_code=${e_learning_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const scorePrePost = (date_from, date_to) => { //ค่าเฉลี่ยของคะแนนการทดสอบในแต่ละหลักสูตร
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/e-learning/analytics/score-pre-post?date_from=${date_from}&date_to=${date_to}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const healthBehaviorSurvey = (date_from, date_to) => { //แบบประเมินพฤติกรรมสุขภาพ
    return new Promise((resolve) => {
        // let url = `${domain}/api/v1/download/csv/health-behavior-survey?date_from=${date_from}&date_to=${date_to}`
        // let header = {}
        // axios.get(url, { headers: header }).then((res) => {
        //     resolve(res)
        // }).catch((error) => {
        //     resolve(false)
        // })
        let url = `${domain}/api/v1/export/excel`
        let body = {
            "export_code": "ex-eva-0201",
            "file_name": "export-excel-evaluation_health_behavior_survey",
            "filter": {
                "date": `${date_from}, ${date_to}`
            }
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const exportAssessment = (export_code, date_from, date_to, properties) => { //แบบประเมิน
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/evaluation/export/${export_code}?date_from=${date_from}&date_to=${date_to}&export_type=excel&order=evaluation_date&sort=asc`
        let body = {
            "file_name": "ผลการประเมิน",
            "sheet_name": "ผลการประเมิน",
            "properties": properties,
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const getAssessmentHistory = (evaluation_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/evaluation/form/data?evaluation_code=${evaluation_code}&order=evaluation_number&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const getAssessmentResultDetail = (doc_number) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/evaluation/form/data/${doc_number}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const getAssessmentResult = (year, department_code) => { //ภาพรวมการทำแบบประเมิน
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/analytics/summary/evaluation-form`
        if (year !== "null" && department_code !== "null") {
            url += `?year=${year}&department_code=${department_code}`
        }
        else if (year !== "null") {
            url += `?year=${year}`
        }
        else if (department_code !== "null") {
            url += `?department_code=${department_code}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const getAssessmentResultYear = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/year-evaluation-form`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const getAssessmentResultDepartment = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/department`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const saveAssessment = (evaluation_code, data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/evaluation/form/${evaluation_code}`
        let body = data
        let header = {
            'platform': platform_name,
            'authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}



export const mentalHealth = (date_from, date_to) => { //แบบประเมินสุขภาพใจ
    return new Promise((resolve) => {
        // let url = `${domain}/api/v1/evaluation/form/mental-health?doc_ref=EVA-MH2410-0006&date_from=${date_from}&date_to=${date_to}`
        // let header = {
        //     'Authorization': `Bearer ${token_public}`,
        //     'Platform': platform_name
        // }
        // axios.get(url, { headers: header }).then((res) => {
        //     resolve(res)
        // }).catch((error) => {
        //     resolve(false)
        // })
        let url = `${domain}/api/v1/export/excel`
        let body = {
            "export_code": "ex-eva-0202",
            "file_name": "export-excel-evaluation_mental_health",
            "filter": {
                "date": `${date_from}, ${date_to}`
            }
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const exportExcelElearning = (date_from, date_to) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/export/excel`
        let data = JSON.stringify({
            "export_code": "ex-learn-0001",
            "file_name": "export-excel-E-learning",
            "filter": [
                {
                    "type": "string",
                    "field": "สังกัด",
                    "start": date_from,
                    "end": date_to
                }
            ]
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'platform': platform_name,
                'authorization': `Bearer ${getStorage(keys.access_token)}`,
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                resolve(false)
            });
    })
}

export const consent = (PID) => { //healthlink consent
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/healthlink/consent?pid=${PID}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const information = (PID) => { //ข้อมูลทางการแพทย์
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/healthlink/information?pid=${PID}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const findDocument = (doc_code, group_code, course_code, pid) => {
    return new Promise((resolve) => {
        // let url = `${domain}/api/v1/microservice/findDocument?document_code=${doc_code}&origin=${origin}&course_group_code=${group_code}&course_code=${course_code}&pid=${pid}`
        let url = `${domain_}/pdf-services/documents/certificate/?origin=${origin}&pid=${pid}&course_number=${course_code}&course_group_number=${group_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const checklist = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/checklist`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const fintCriteria = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/criteria?order=checklist_group_code,healthcheck_code&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const addCriteria = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/criteria`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const updateCriteria = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/criteria`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteCriteria = (healthcheck_code, checklist_group_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/criteria?healthcheck_code=${healthcheck_code}&checklist_group_code=${checklist_group_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const operation = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/operation?order=line_number&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const condition = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/condition?order=line_number&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const genderCriteria = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/gender?order=line_number&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const age = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/age?order=line_number&sort=asc`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const project = (year, search, project_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/project`
        if (year !== 'null') {
            url += `?year=${year}`
        }
        if (search) {
            url += `&search=${search}`
        }
        if (project_code) {
            url += `&project_code=${project_code}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const addProject = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/project`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const editProject = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/project`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteProject = (project_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/project?project_code=${project_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const projectYear = () => { //dropdown - กลุ่มปี
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/project-year`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const toggle = (project_code) => { // Active/Inactive โครงการ
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/manage/project/toggle?project_code=${project_code}`
        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Authorization': `Bearer ${getStorage(keys.access_token)}`,
                'Platform': platform_name
            }
        }
        axios.request(config)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                resolve(false)
            });
    })
}

export const contact = (data) => { //ติดต่อ ==> นักสร้างเสริมหรือแอดมิน
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/notification/contact`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const memberList = (year, project_code, page, age, department_code) => { //รายชื่อสมาชิกที่เข้าร่วมโครงการ
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/project/member-list?year=${year}&project_code=${project_code}&page=${page}`
        if (department_code) {
            url += `&department_code=${department_code}`
        }
        if (age) {
            url += `&age=${age}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const memberGraph = (project_code, field, department_code) => { //กราฟรายชื่อสมาชิกที่เข้าร่วมโครงการ
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/project/summary/graph?project_code=${project_code}`
        if (field) {
            url += `&field=${field}`
        }
        if (department_code) {
            url += `&department_code=${department_code}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const leaveProject = (data) => { //ออกจากการเป็นสมาชิกโครงการ
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/project/member/leave-project`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const followUp = (data) => { //อัพเดทข้อมูลของรายชื่อผู้เข้าร่วมโครงการ
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/project/member/follow-up`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const patientList = (year, project_code, page, department_code, search, result_field, result) => { //รายชื่อกลุ่มเป้าหมาย จาก Checkup
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/checkup/patient-list?order=full_name&sort=asc&year=${year}&project_code=${project_code}&page=${page}`
        if (department_code) {
            url += `&department_code=${department_code}`
        }
        if (search) {
            url += `&search=${search}`
        }
        if (result_field) {
            url += `&${result_field}=${result}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const member = (data) => { //แก้ไขสมาชิกที่เข้าร่วมโครงการ (เพิ่มคนเข้า)
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/project/member`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const exportExcel = (department_code, project_code, year) => { //Export Excel สมาชิกในโครงการ
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/health/project/export/excel?department_code=${department_code}`
        let body = {
            "project_code": project_code,
            "year": year,
            "export_file_name": "project-member",
            "export_sheet_name": "project-member"
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const congenitalDisease = () => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/lookup/congenital-disease`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const contacts = (search, code_) => { //เมนูติดต่อประสานงาน
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/contacts/contact`
        if (search) {
            url += `?search=${search}`
        }
        if (code_) {
            url += `?contact_code=${code_}`
        }
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.get(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const addContacts = (data) => { //เมนูติดต่อประสานงาน
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/contacts/contact`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const deleteContacts = (contact_code) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/contacts/contact?contact_code=${contact_code}`
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name
        }
        axios.delete(url, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const editContacts = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/contacts/contact`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const contactMessage = (data) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/contacts/contact/message`
        let body = data
        let header = {
            'Authorization': `Bearer ${getStorage(keys.access_token)}`,
            'Platform': platform_name,
            'Content-Type': 'application/json'
        }
        axios.put(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}

export const confirmPassword = (password) => {
    return new Promise((resolve) => {
        let url = `${domain}/api/v1/system/confirmPassword`
        let body = {
            "password": password
        }
        let header = {
            'Authorization': `Bearer ${localStorage.getItem('AccessToken')}`,
            'Platform': 'mod-healthsystem-dashboard',
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then((res) => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
        })
    })
}